export default "__VITE_ASSET__BVquokLA__"